<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>sync_problem</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>
                &nbsp;Correcciones Puntuales (utilizar bajo su propia
                responsabilidad...)
              </div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-container>
        <v-checkbox
          label="Corregir Estado Acuerdo"
          v-model="corregirEstadoAcuerdo"></v-checkbox>

        <v-card v-if="corregirEstadoAcuerdo">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-text-field
                  v-model="numeroAcuerdo"
                  label="Acuerdo Nº"
                  type="number"></v-text-field
              ></v-col>
              <v-col>
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>

              <v-col
                ><v-btn small color="primary" @click="buscarAcuerdoPorNumero"
                  >Buscar</v-btn
                ></v-col
              >
            </v-row>

            <v-row dense v-if="acuerdoId">
              <v-col>
                <span class="body-1"
                  >El estado Acutual es:
                  {{
                    listEstadosAcuerdo.find((x) => x.id == acuerdo.estadoId)
                      .descripcion
                  }}</span
                >
              </v-col>
            </v-row>

            <v-row dense v-if="acuerdoId" align="center">
              <v-col>
                <v-autocomplete
                  :items="listEstadosAcuerdo"
                  v-model="nuevoEstadoAcuerdoId"
                  item-text="descripcion"
                  item-value="id"
                  label="Cambiar Estado a"></v-autocomplete>
              </v-col>
              <v-col
                ><v-text-field
                  v-model="comentarios"
                  label="Ingrese el Motivo"
                  type="text"></v-text-field
              ></v-col>
              <v-col
                ><v-btn small dark color="red" @click="cambiarEstadoAcuerdo"
                  >Confirmar</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Cancelar Crédito (Sin Saldo)"
          v-model="corregisEstadoCredito"></v-checkbox>

        <v-card v-if="corregisEstadoCredito">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-text-field
                  v-model="numeroCredito"
                  label="Crédito Nº"
                  type="number"></v-text-field
              ></v-col>
              <v-col>
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>

              <v-col
                ><v-btn small color="primary" @click="buscarCreditoPorNumero"
                  >Buscar</v-btn
                ></v-col
              >
            </v-row>

            <v-row dense v-if="creditoId">
              <v-col>
                <span class="body-1">El estado Actual es Activo</span>
              </v-col>
            </v-row>

            <v-row dense v-if="creditoId" align="center">
              <v-col
                ><v-text-field
                  v-model="comentarios"
                  label="Ingrese el Motivo"
                  type="text"></v-text-field
              ></v-col>
              <v-col
                ><v-btn small dark color="red" @click="cancelarCredito"
                  >Cancelar Crédito</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Cancelar Crédito (Cuponizate)"
          v-model="corregirEstadoCuponizate"></v-checkbox>
        <v-card v-if="corregirEstadoCuponizate">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-text-field
                  v-model="numeroCredito"
                  label="Crédito Nº"
                  type="number"></v-text-field
              ></v-col>
              <v-col>
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>

              <v-col
                ><v-btn small color="primary" @click="buscarCreditoPorNumero"
                  >Buscar</v-btn
                ></v-col
              >
            </v-row>

            <v-row dense v-if="creditoId">
              <v-col>
                <span class="body-1">El estado Actual es Activo</span>
              </v-col>
            </v-row>

            <v-row dense v-if="creditoId" align="center">
              <v-col
                ><v-text-field
                  v-model="comentarios"
                  label="Ingrese el Motivo"
                  type="text"></v-text-field
              ></v-col>
              <v-col
                ><v-btn small dark color="red" @click="cancelarCuponizate"
                  >Cancelar Crédito</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Cancelar créditos Cuponizate Masivo"
          v-model="cancelarCuponizateMasivo"></v-checkbox>

        <v-card v-if="cancelarCuponizateMasivo">
          <v-card-text>
            <v-row dense align="center">
              <v-col cols="4">
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="filtro.empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-alert color="warning" dark dense>
                  El archivo debe tener formato Excel, con una columna con el
                  encabezado Numero (con el número de crédito).
                </v-alert>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <v-file-input
                  v-model="archivoCancelacionCuponizate"
                  placeholder="Seleccione el archivo Excel"
                  label="Archivo"
                  prepend-icon="mdi-paperclip">
                </v-file-input>
              </v-col>
            </v-row>

            <v-row align="right">
              <v-col
                ><v-btn
                  small
                  color="primary"
                  @click="iniciarCancelacionCuponizateMasiva"
                  >Procesar</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Anular Crédito"
          v-model="anularEstadoCredito"></v-checkbox>

        <v-card v-if="anularEstadoCredito">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-text-field
                  v-model="numeroCredito"
                  label="Crédito Nº"
                  type="number"></v-text-field
              ></v-col>
              <v-col>
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>

              <v-col
                ><v-btn
                  small
                  color="primary"
                  @click="buscarCreditoPorNumeroAnulacion"
                  >Buscar</v-btn
                ></v-col
              >
            </v-row>

            <v-row dense v-if="creditoId">
              <v-col>
                <span class="body-1">El estado Actual es Activo</span>
              </v-col>
            </v-row>

            <v-row dense v-if="creditoId" align="center">
              <v-col
                ><v-text-field
                  v-model="comentarios"
                  label="Ingrese el Motivo"
                  type="text"></v-text-field
              ></v-col>
              <v-col
                ><v-btn small dark color="red" @click="anularCredito"
                  >Anular Crédito</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Mover Punitorio Condonado"
          v-model="moverPunitorioCondonado"></v-checkbox>

        <v-card v-if="moverPunitorioCondonado">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-text-field
                  v-model="numeroCredito"
                  label="Crédito Nº"
                  type="number"></v-text-field
              ></v-col>
              <v-col>
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>

              <v-col
                ><v-btn small color="primary" @click="buscarCreditoPorNumero"
                  >Buscar</v-btn
                ></v-col
              >
            </v-row>

            <v-row dense v-if="creditoId">
              <v-col>
                <span class="body-1"
                  >Indique de qué cuota a qué cuota mover los punitorios
                  condonado</span
                >
              </v-col>
            </v-row>

            <v-row dense v-if="creditoId" align="center">
              <v-col
                ><v-text-field
                  v-model="cuotaDesde"
                  label="Sacar de Cuota Nº "
                  type="number"></v-text-field
              ></v-col>
              <v-col
                ><v-text-field
                  v-model="cuotaHasta"
                  label="Mover a Cuota Nº "
                  type="number"></v-text-field
              ></v-col>
              <v-col
                ><v-btn
                  small
                  dark
                  color="red"
                  @click="confirmarMoverPunitorioCondonado"
                  >Confirmar</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Pasar Cuota Acuerdo"
          v-model="pasarCuotaAcuerdo"></v-checkbox>

        <v-card v-if="pasarCuotaAcuerdo">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-text-field
                  v-model="numeroAcuerdo"
                  label="Acuerdo Nº"
                  type="number"></v-text-field
              ></v-col>
              <v-col>
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>

              <v-col
                ><v-btn small color="primary" @click="buscarAcuerdoPorNumero"
                  >Buscar</v-btn
                ></v-col
              >
            </v-row>

            <v-row dense v-if="acuerdoId">
              <v-col>
                <span class="body-1"
                  >Indique de qué cuota a qué cuota mover la cobranza</span
                >
              </v-col>
            </v-row>

            <v-row dense v-if="acuerdoId" align="center">
              <v-col
                ><v-text-field
                  v-model="cuotaDesde"
                  label="Sacar de Cuota Nº "
                  type="number"></v-text-field
              ></v-col>
              <v-col
                ><v-text-field
                  v-model="cuotaHasta"
                  label="Mover a Cuota Nº "
                  type="number"></v-text-field
              ></v-col>
              <v-col
                ><v-btn
                  small
                  dark
                  color="red"
                  @click="confirmarMoverCobranzaCuotaAcuerdo"
                  >Confirmar</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Corregir Estado Cuota Crédito"
          v-model="corregirEstadoCredito"></v-checkbox>

        <v-card v-if="corregirEstadoCredito">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-text-field
                  v-model="numeroCredito"
                  label="Crédito Nº"
                  type="number"></v-text-field
              ></v-col>
              <v-col>
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>

              <v-col
                ><v-btn small color="primary" @click="buscarCreditoPorNumero"
                  >Buscar</v-btn
                ></v-col
              >
            </v-row>

            <v-row dense v-if="creditoId">
              <v-col>
                <span class="body-1"
                  >Indique a qué cuota le quiere cambiar el estado</span
                >
              </v-col>
            </v-row>

            <v-row dense v-if="creditoId" align="center">
              <v-col
                ><v-text-field
                  v-model="cuotas"
                  label="Nº Cuota"
                  type="number"></v-text-field
              ></v-col>
              <v-col
                ><v-btn
                  small
                  dark
                  color="red"
                  @click="confirmarcorregirEstadoCredito"
                  >Corregir</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Marca/Desmarca incobrable"
          v-model="marcarIncobrable"></v-checkbox>

        <v-card v-if="marcarIncobrable">
          <v-card-text>
            <v-row dense align="center">
              <v-col cols="4">
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="filtro.empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>

              <v-col cols="4">
                <v-radio-group v-model="indicarPor">
                  <v-radio
                    label="Marcar"
                    class="caption"
                    key="marcar"
                    value="marcar"></v-radio>
                  <v-radio
                    label="Desmarcar"
                    class="caption"
                    key="desmarcar"
                    value="desmarcar"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="4" v-if="indicarPor == 'marcar'">
                <v-text-field
                  v-model="filtro.fecha"
                  label="Fecha Marca"
                  type="date"
                  prepend-icon="event"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-alert color="warning" dark dense>
                  El archivo debe tener formato Excel, con una columna con el
                  encabezado Numero (con el número de crédito).
                </v-alert>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <v-file-input
                  v-model="archivoMarcacion"
                  placeholder="Seleccione el archivo Excel"
                  label="Archivo"
                  prepend-icon="mdi-paperclip">
                </v-file-input>
              </v-col>
            </v-row>

            <v-row align="right">
              <v-col
                ><v-btn small color="primary" @click="iniciarMarcaDesmarca"
                  >Procesar</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Corregir Fecha Cierre Reclamo"
          v-model="corregirFechaCierreReclamo"></v-checkbox>

        <v-card v-if="corregirFechaCierreReclamo">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-text-field
                  v-model="numeroReclamo"
                  label="Reclamo Nº"
                  type="number"></v-text-field
              ></v-col>
              <v-col>
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>

              <v-col
                ><v-btn small color="primary" @click="buscarReclamoPorNumero"
                  >Buscar</v-btn
                ></v-col
              >
            </v-row>

            <v-row dense v-if="reclamoId">
              <v-col>
                <span class="body-1"
                  >Indique la fecha del cierre de reclamo</span
                >
              </v-col>
            </v-row>

            <v-row dense v-if="reclamoId" align="center">
              <v-col
                ><v-text-field
                  v-model="fechaCierre"
                  label="Fecha Cierre"
                  type="date"></v-text-field
              ></v-col>
              <v-col
                ><v-btn
                  small
                  dark
                  color="red"
                  @click="confirmarCorregirFechaCierreReclamo"
                  >Corregir</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox label="Anular Reclamo" v-model="anularReclamo"></v-checkbox>

        <v-card v-if="anularReclamo">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-text-field
                  v-model="numeroReclamo"
                  label="Reclamo Nº"
                  type="number"></v-text-field
              ></v-col>
              <v-col>
                <v-autocomplete
                  :items="listEmpresas"
                  v-model="empresaId"
                  item-text="nombre"
                  item-value="id"
                  label="De la Empresa"></v-autocomplete>
              </v-col>
              <v-col
                ><v-btn small color="primary" @click="buscarReclamoPorNumero"
                  >Buscar</v-btn
                ></v-col
              >
            </v-row>
            <v-row dense v-if="reclamoId" align="center">
              <v-col
                ><v-btn small dark color="red" @click="confirmarAnularReclamo"
                  >Anular Reclamo</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Actualizar Estadísticas Base"
          v-model="updateStats"></v-checkbox>

        <v-card v-if="updateStats">
          <v-card-text>
            <v-row dense align="center">
              <v-col
                ><v-btn small color="primary" @click="iniciarUpdateStats"
                  >Comenzar</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox label="Reversar Pago" v-model="reversoPago"></v-checkbox>

        <v-card v-if="reversoPago">
          <v-card-text>
            <v-row>
              <v-col>
                <v-alert color="warning" dark dense>
                  El archivo debe tener formato Excel, con una columna con el
                  encabezado ReferenciaId.
                </v-alert>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <v-file-input
                  v-model="reversoPago"
                  placeholder="Seleccione el archivo Excel"
                  label="Archivo"
                  prepend-icon="mdi-paperclip">
                </v-file-input>
              </v-col>
            </v-row>

            <v-row align="right">
              <v-col
                ><v-btn small color="primary" @click="reversarPago"
                  >Procesar</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          label="Recargar Tabla Numeración Geográfica"
          v-model="recargarNumeracionGeografica"></v-checkbox>

        <v-card v-if="recargarNumeracionGeografica">
          <v-card-text>
            <v-row align="right">
              <v-col
                ><v-btn small color="primary" @click="recargarNumGeo"
                  >Recargar</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>

        <v-checkbox
          v-model="modificarSecuencia"
          label="Modificar secuencia de transferencia BIND"
          color="primary"
          hide-details
          class="mb-3" />

        <v-expand-transition>
          <v-card v-if="modificarSecuencia" outlined class="pa-2">
            <v-card-title class="text-subtitle-1 font-weight-medium">
              Configuración de la secuencia
            </v-card-title>

            <v-card-text>
              <v-row align="center">
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="empresaSecuenciaId"
                    :items="listEmpresas"
                    item-text="nombre"
                    item-value="id"
                    label="Empresa"
                    outlined
                    dense
                    hide-details="auto" />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    v-model.number="ultimoValorSecuencia"
                    label="Último valor"
                    type="number"
                    min="0"
                    outlined
                    dense
                    hide-details="auto" />
                </v-col>

                <v-col cols="12" md="3" class="d-flex">
                  <v-btn color="primary" @click="updateSecuencia">
                    Modificar secuencia
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-expand-transition>
      </v-container>

      <v-divider></v-divider>
    </v-card>

    <app-loading :loading="saving"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>
    </template>
  </v-container>
</template>

<script>
import { http } from "@/axios";

import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    saving: false,
    listEmpresas: [],
    listSucursales: [],
    listEstadosAcuerdo: [],
    empresaId: 1,
    numeroAcuerdo: 0,
    acuerdoId: null,
    corregirEstadoAcuerdo: false,
    nuevoEstadoAcuerdoId: 0,
    comentarios: "",
    corregisEstadoCredito: false,
    corregirEstadoCuponizate: false,
    anularEstadoCredito: false,
    numeroCredito: 0,
    creditoId: null,
    moverPunitorioCondonado: false,
    cuotaDesde: 0,
    cuotaHasta: 0,
    empresaSecuenciaId: 0,
    sucursalSecuenciaId: 0,
    codigoSecuencia: "",
    ultimoValorSecuencia: 0,
    pasarCuotaAcuerdo: false,
    corregirEstadoCredito: false,
    marcarIncobrable: false,
    cancelarCuponizateMasivo: false,
    reversoPago: null,
    recargarNumeracionGeografica: false,
    modificarSecuencia: false,
    mostrarReversarPago: false,
    cuotas: 0,
    indicarPor: "marcar",
    filtro: { empresaId: 0, fecha: null },
    archivoMarcacion: [],
    archivoCancelacionCuponizate: [],
    corregirFechaCierreReclamo: false,
    reclamoId: null,
    numeroReclamo: 0,
    fechaCierre: null,
    anularReclamo: null,
    updateStats: false,
  }),
  props: {
    cajaId: { type: Number },
    cajaMultiMoneda: { type: Boolean },
    fechaCaja: { type: String },
    accionCompleta: { type: Function },
    isSubTask: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
  },
  async created() {
    this.loadEmpresas();
    // this.loadSucursales();
    this.listEstadosAcuerdo.push({ id: 2, descripcion: "Activo" });
    this.listEstadosAcuerdo.push({ id: 3, descripcion: "Cancelado" });
    this.listEstadosAcuerdo.push({ id: 4, descripcion: "Anulado" });
  },
  computed: {
    ...mapGetters(["getActionFromLink", "user"]),
  },
  watch: {},
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "hideActiveTask",
      "hideActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),

    async buscarAcuerdoPorNumero() {
      if (this.numeroAcuerdo == 0) {
        this.alertWarning("Por favor, ingrese el número del acuerdo.");
        return;
      }
      if (this.empresaId == 0) {
        this.alertWarning("Por favor, seleccione la empresa.");
        return;
      }

      this.saving = true;
      try {
        var result = await http.get(
          "acuerdos/getbynumero?empresaId=" +
            this.empresaId +
            "&numeroAcuerdo=" +
            this.numeroAcuerdo,
        );

        this.acuerdo = result;
        this.acuerdoId = result.id;
        console.log(result);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },
    async buscarCreditoPorNumero() {
      if (this.numeroCredito == 0) {
        this.alertWarning("Por favor, ingrese el número del crédito.");
        return;
      }
      if (this.empresaId == 0) {
        this.alertWarning("Por favor, seleccione la empresa.");
        return;
      }

      this.saving = true;

      try {
        var result = await http.get(
          "creditos/getbynumero?empresaId=" +
            this.empresaId +
            "&numeroCredito=" +
            this.numeroCredito,
        );

        this.credito = result;
        this.creditoId = result.id;
        console.log(result);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },
    async buscarCreditoPorNumeroAnulacion() {
      if (this.numeroCredito == 0) {
        this.alertWarning("Por favor, ingrese el número del crédito.");
        return;
      }
      if (this.empresaId == 0) {
        this.alertWarning("Por favor, seleccione la empresa.");
        return;
      }

      this.saving = true;
      try {
        var result = await http.get(
          "creditos/getbynumeroparaanulacion?empresaId=" +
            this.empresaId +
            "&numeroCredito=" +
            this.numeroCredito,
        );

        this.credito = result;
        this.creditoId = result.id;
        console.log(result);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },
    async anularCredito() {
      if (!this.creditoId) {
        this.alertWarning("Por favor, realice la búsqueda del crédito.");
        return;
      }

      try {
        var params = {};
        params.creditoId = this.credito.id;
        params.subEstadoId = 971; // anulada
        params.motivo = this.comentarios;
        params.esCorreccionPuntual = true;

        await http.post(
          "creditos/cambiarestado",
          JSON.stringify({ parametros: params }),
        );
        this.alertSuccess("El cambio ha sido registrado.");

        // limpio
        this.credito = null;
        this.creditoId = null;
        this.comentarios = "";
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async cambiarEstadoAcuerdo() {
      if (!this.acuerdoId || this.acuerdoId == 0) {
        this.alertWarning("Por favor, realice la búsqueda del acuerdo.");
        return;
      }

      if (this.nuevoEstadoAcuerdoId == 0) {
        this.alertWarning("Por favor, seleccione el nuevo estado del acuerdo.");
        return;
      }

      if (this.nuevoEstadoAcuerdoId == this.acuerdo.estadoId) {
        this.alertWarning(
          "El acuerdo ingresado ya está en el estado que seleccionó.",
        );
        return;
      }

      try {
        var params = {};
        params.acuerdoId = this.acuerdo.id;
        params.estadoId = this.nuevoEstadoAcuerdoId;
        params.motivo = this.comentarios;

        await http.post(
          "acuerdos/cambiarestado",
          JSON.stringify({ parametros: params }),
        );
        this.alertSuccess("El cambio ha sido registrado.");

        // limpio
        this.acuerdo = null;
        this.acuerdoId = 0;
        this.nuevoEstadoAcuerdoId = 0;
        this.comentarios = "";
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async cancelarCredito() {
      if (!this.creditoId) {
        this.alertWarning("Por favor, realice la búsqueda del crédito.");
        return;
      }

      try {
        var params = {};
        params.creditoId = this.credito.id;
        params.subEstadoId = 991; // cancelado
        params.motivo = this.comentarios;
        params.fechaCancela = new Date();
        params.esCorreccionPuntual = true;

        await http.post(
          "creditos/cambiarestado",
          JSON.stringify({ parametros: params }),
        );
        this.alertSuccess("El cambio ha sido registrado.");

        // limpio
        this.credito = null;
        this.creditoId = null;
        this.comentarios = "";
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },

    async cancelarCuponizate() {
      if (!this.creditoId) {
        this.alertWarning("Por favor, realice la búsqueda del crédito.");
        return;
      }

      try {
        var params = {};
        params.id = this.credito.id;
        // params.Usuario =
        // params.subEstadoId = 991; // cancelado
        // params.motivo = this.comentarios;
        // params.fechaCancela = new Date();
        // params.esCorreccionPuntual = true;
        alert(JSON.stringify(params));
        await http.post(
          "creditos/cancelarCreditoCuponizate",
          JSON.stringify(params),
        );
        this.alertSuccess("El cambio ha sido registrado.");

        // limpio
        this.credito = null;
        this.creditoId = null;
        this.comentarios = "";
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },

    async confirmarMoverPunitorioCondonado() {
      if (!this.creditoId) {
        this.alertWarning("Por favor, realice la búsqueda del crédito.");
        return;
      }

      if (!this.cuotaDesde || this.cuotaDesde <= 0) {
        this.alertWarning(
          "Por favor, indique la cuota desde donde sacar los punitorios.",
        );
        return;
      }

      if (!this.cuotaHasta || this.cuotaHasta <= 0) {
        this.alertWarning(
          "Por favor, indique la cuota a la cual mover los punitorios.",
        );
        return;
      }

      try {
        var params = {};
        params.creditoId = this.creditoId;
        params.cuotaDesde = this.cuotaDesde;
        params.cuotaHasta = this.cuotaHasta;

        await http.post(
          "creditos/moverpunitorioscondonados",
          JSON.stringify({ parametros: params }),
        );
        this.alertSuccess("El camibio ha sido registrado.");

        // limpio
        this.credito = null;
        this.creditoId = null;
        this.comentarios = "";
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async confirmarMoverCobranzaCuotaAcuerdo() {
      if (!this.acuerdoId) {
        this.alertWarning("Por favor, realice la búsqueda del acuerdo.");
        return;
      }

      if (!this.cuotaDesde || this.cuotaDesde <= 0) {
        this.alertWarning(
          "Por favor, indique la cuota desde donde sacar la cobranza.",
        );
        return;
      }

      if (!this.cuotaHasta || this.cuotaHasta <= 0) {
        this.alertWarning(
          "Por favor, indique la cuota a la cual mover la cobranza.",
        );
        return;
      }

      try {
        var params = {};
        params.acuerdoId = this.acuerdoId;
        params.cuotaDesde = this.cuotaDesde;
        params.cuotaHasta = this.cuotaHasta;

        await http.post(
          "acuerdos/movercobranzacuota",
          JSON.stringify({ parametros: params }),
        );
        this.alertSuccess("El cambio ha sido registrado.");

        // limpio
        this.credito = null;
        this.creditoId = null;
        this.comentarios = "";
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async confirmarcorregirEstadoCredito() {
      if (!this.creditoId) {
        this.alertWarning("Por favor, realice la búsqueda del crédito.");
        return;
      }

      if (!this.cuotas || this.cuotas <= 0) {
        this.alertWarning("Por favor, indique la cuota.");
        return;
      }

      try {
        var params = {};
        params.creditoId = this.creditoId;
        params.cuota = this.cuotas;

        await http.post(
          "creditos/fixestadocuota",
          JSON.stringify({ parametros: params }),
        );
        this.alertSuccess("El cambio ha sido registrado.");

        // limpio
        this.credito = null;
        this.creditoId = null;
        this.comentarios = "";
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },

    async iniciarCancelacionCuponizateMasiva() {
      if (this.filtro.empresaId == 0) {
        return this.alertWarning("Por favor seleccione una empresa");
      }

      if (this.archivoCancelacionCuponizate.length == 0) {
        return this.alertWarning("Por favor selecione un archivo excel");
      }
      this.saving = true;
      let request = new FormData();
      request.append("archivo", this.archivoCancelacionCuponizate);
      request.append("empresaId", this.filtro.empresaId);
      //alert(this.filtro.empresaId);
      try {
        // request.append("fecha", this.filtro.fecha);
        var result = await http.post(
          "creditos/cancelarCuponizateMasivo",
          request,
        );

        if (result.length == 0) {
          this.saving = false;
          return this.alertSuccess("La acción se realizó correctamente");
        } else {
          alert(result);
        }
      } catch (err) {
        this.alertError(err);
      }
      this.saving = false;
    },

    async iniciarMarcaDesmarca() {
      if (this.filtro.empresaId == 0) {
        return this.alertWarning("Por favor seleccione una empresa");
      }

      if (this.archivoMarcacion.length == 0) {
        return this.alertWarning("Por favor selecione un archivo excel");
      }

      this.saving = true;

      let request = new FormData();

      request.append("archivo", this.archivoMarcacion);
      request.append("empresaId", this.filtro.empresaId);

      try {
        if (this.indicarPor == "marcar") {
          if (this.filtro.fecha == null) {
            return this.alertWarning("Por favor selecione una fecha");
          } else {
            request.append("fecha", this.filtro.fecha);
            var result = await http.post(
              "creditos/marcaincobrablesmasivo",
              request,
            );
          }
        } else {
          var result = await http.post(
            "creditos/desmarcaincobrablesmasivo",
            request,
          );
        }

        // console.log('llega esto!!!!!!!!!!!!!!!!!!!!!');
        // console.log(result);

        if (result.length == 0) {
          this.saving = false;
          return this.alertSuccess("La acción se realizó correctamente");
        } else {
          alert(result);
        }

        // //limpio y esot??? no borra los campos..
        //   this.filtro.empresaId=0;
        //   this.archivoMarcacion= [];
        //   this.filtro.fecha= null;
      } catch (err) {
        this.alertError(err);
      }
      this.saving = false;
    },

    async buscarReclamoPorNumero() {
      if (this.numeroReclamo == 0) {
        this.alertWarning("Por favor, ingrese el número del reclamo.");
        return;
      }
      if (this.empresaId == 0) {
        this.alertWarning("Por favor, seleccione la empresa.");
        return;
      }
      this.saving = true;
      try {
        var result = await http.get(
          "reclamos/pornumero?empresaId=" +
            this.empresaId +
            "&numeroReclamo=" +
            this.numeroReclamo,
        );
        this.reclamoId = result.id;
        console.log(result);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },
    async confirmarCorregirFechaCierreReclamo() {
      if (!this.numeroReclamo) {
        this.alertWarning("Por favor, realice la búsqueda del reclamo.");
        return;
      }

      try {
        var params = {};
        params.reclamoId = this.reclamoId;
        params.nuevaFechaCierre = this.fechaCierre;

        await http.put(
          "reclamos/modificafechacierre",
          JSON.stringify({
            reclamoId: this.reclamoId,
            nuevaFechaCierre: this.fechaCierre,
          }),
        );
        this.alertSuccess("El cambio ha sido registrado.");

        // limpio

        this.reclamoId = null;
        //this.comentarios = '';
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async confirmarAnularReclamo() {
      if (!this.numeroReclamo) {
        this.alertWarning("Por favor, realice la búsqueda del reclamo.");
        return;
      }

      try {
        var params = {};
        params.reclamoId = this.reclamoId;

        await http.put(
          "reclamos/anulareclamo",
          JSON.stringify({ reclamoId: this.reclamoId }),
        );
        this.alertSuccess("El cambio ha sido registrado.");

        // limpio

        this.reclamoId = null;
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async iniciarUpdateStats() {
      try {
        await http.post("adhoc/updatestats", {});
        this.alertSuccess("Proceso finalizado.");

        // limpio

        this.reclamoId = null;
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async loadEmpresas() {
      this.saving = true;
      try {
        var result = await http.get("empresas"); // traigo todas
        this.listEmpresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },

    async loadSucursales() {
      this.saving = true;
      try {
        var result = await http.get("sucursales"); // traigo todas
        this.listSucursales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },

    async save() {
      if (this.cajaMultiMoneda)
        this.model.cotizacion = this.listMonedas.find(
          (m) => m.id == this.model.monedaId,
        ).cotizacion;

      if (!this.validarDatos()) return;

      this.saving = true;

      try {
        await http.post(
          "cajas/altamovimiento",
          JSON.stringify({ parametros: this.model }),
        );

        this.alertSuccess("El movimiento ha sido generado.");
        this.emitAccionCompleta();

        this.hide(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },

    async recargarNumGeo() {
      // var params = {};
      // params.ticket = "5B0FA15E-7FA0-4510-9C54-F74CC4059E30";

      await http.post(
        "External/fix_recargarbasenumeracion?ticket=5B0FA15E-7FA0-4510-9C54-F74CC4059E30",
      );
      this.alertSuccess("Se han recargado las numeraciones geográficas.");
    },

    async updateSecuencia() {
      try {
        var params = {};
        params.empresaId = this.empresaSecuenciaId;
        params.sucursalId = 0;
        params.codigoSecuencia = "BindTransferOriginId";
        params.ultimoValor = this.ultimoValorSecuencia;

        await http.post(
          "impactos/updateSecuencia",
          JSON.stringify({ parametros: params }),
        );
        this.alertSuccess("La secuencia ha sido modificada.");

        // limpio
        this.empresaSecuenciaId = null;
        this.sucursalSecuenciaId = 0;
        // this.codigoSecuencia = null;
        this.ultimoValorSecuencia = 0;
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },

    validarDatos() {
      if (!this.model.cajaId) {
        this.alertWarning("No se estableció la Caja.");
        return false;
      }

      //tipo gestión telefónica
      if (
        this.listConceptos.find((c) => c.id == this.model.conceptoId) &&
        this.listConceptos.find((c) => c.id == this.model.conceptoId)
          .conceptoMovimientoAOtraCajaId > 0
      ) {
        if (!(this.model.cajaDestinoId > 0)) {
          this.alertWarning("Debe elegir la Caja Destino del Movimiento.");
          return false;
        }
      }

      if (!(this.model.importe > 0)) {
        this.alertWarning("Debe ingresar el Importe del Movimiento.");
        return false;
      }
      return true;
    },
    async loadCajas() {
      this.listCajas = [];
      this.loadingCajas = true;
      try {
        var result = await http.get("cajas");
        this.listCajas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingCajas = false;
    },
    async loadConceptosMovimientos() {
      this.saving = true;
      try {
        await http
          .get(
            "cajas/listconceptosmovimientos?incluirDeSistema=false&limit=100&page=1",
          )
          .then((res) => {
            this.listConceptos = res.list;
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },
    async loadMonedas() {
      this.listMonedas = [];
      this.loadingMonedas = true;
      try {
        var result = await http.get("monedas");
        this.listMonedas = result.list;
        this.model.monedaId = this.listMonedas.find(
          (m) => m.predeterminada == true,
        ).id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingMonedas = false;
    },

    async reversarPago() {
      var self = this;

      if (!this.reversoPago.name.includes(".xlsx")) {
        this.reversoPago = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.reversoPago);
      formData.append("separador", ";");

      try {
        await http
          .post("businesscore/prereversarpago", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado...",
              );

              self.loading = true;
              self.downloadFile(resp, "Reverso_Pago.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async downloadFile(file) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(resp.fileName, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    emitAccionCompleta() {
      if (this.accionCompleta) this.accionCompleta();

      this.$emit("accion-completa");
    },
  },
};
</script>
